module.exports = __webpack_public_path__ + "assets/img/pager.9890a2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pager.jpg
// module id = 566
// module chunks = 1